import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../error.service';
import { ConfigService } from '../services/config.service';

@Injectable()
export class AuthService {
    authTokenURL = 'token';
    authRefreshURL = 'refresh';
    authChangehURL = 'change';

    constructor(
        private http: HttpClient,
        private error: ErrorService
    ) {}

    auth(username: string, password: string): Observable<any> {
        const credentials = { username: username, password: password };
        return this.http.post(ConfigService.getAuthEndpoint() + this.authTokenURL, credentials).pipe(
            catchError(this.error.handleAuthError('auth', null))
        );
    }

    switchCustomer(username: string, customerName: string): Observable<any> {
        const customerSwitchRequest = { username: username, customerName: customerName};
        return this.http.post(ConfigService.getAuthEndpoint() + this.authChangehURL, customerSwitchRequest).pipe(
            catchError(this.error.handleAuthError('auth', null))
        );
    }

    refresh(): Observable<any> {
        return this.http.get(ConfigService.getAuthEndpoint() + this.authRefreshURL).pipe(
            catchError(this.error.handleAuthError('auth', null))
        );
    }


}


